import * as React from 'react'
import {
    TextFieldSeeker,
    ModalSeeker,
    GridSeeker,
    TableSeekerContextProvider
} from 'ui-seeker/core'
import SavedFiltersTable from "./Table";
import {useSavedFilters} from "./@hooks";
import AppAjaxButtonSeeker from "../../../../../@components/Base/AjaxButton";
import {DASHBOARD} from "app/@common/constants";
import {useContextSelector} from "use-context-selector";
import {CommonFiltersSavedContext} from "../../../context";

export default function SavedModal({ open=false, controller }) {
    const {name, setName, page, buildFilterParams} = useSavedFilters()
    const updatePrevStateTable = useContextSelector(CommonFiltersSavedContext, ({updatePrevState}) => updatePrevState)
    const dataSavedFilters = useContextSelector(CommonFiltersSavedContext, ({state}) => state.dataSavedFilters)
    return <ModalSeeker
        isOpen={open}
        controller={controller}
        title={"Set the name for your dashboard"}
        okBtn={false}
        cancelBtn={false}
        size={"md"}
    >
        <GridSeeker container spacing={2} style={{ marginBottom: 14 }} alignItems="center">
            <GridSeeker item size={10}>
                <TextFieldSeeker label="Name" value={name} onChange={e => setName(e.currentTarget.value)} />
            </GridSeeker>
            <GridSeeker item size={2} style={{ marginTop: 6 }}>
                <AppAjaxButtonSeeker
                    urlAjax={`${DASHBOARD?.[page]?.SAVE}`}
                    data={{
                        name: name,
                        default: false,
                        filters_raw: buildFilterParams(true)
                    }}
                    label={"SAVE"}
                    method="POST"
                    icon={"save"}
                    onAjax={(data) => {
                        setName("")
                        if (dataSavedFilters.some(item => item.preset_key === data.preset_key)) {
                            updatePrevStateTable(prev => ({
                                ...prev,
                                dataSavedFilters: prev.dataSavedFilters.map(item =>
                                    item.preset_key === data.preset_key ? data : item
                                )
                            }))
                        } else {
                            updatePrevStateTable(prev => ({
                                ...prev,
                                dataSavedFilters: [...prev.dataSavedFilters, data]
                            }))
                        }
                        controller()
                    }}
                />
            </GridSeeker>
        </GridSeeker>
        <SavedFiltersTable controller={controller} />
    </ModalSeeker>
}
